<template>
  <div class="real-time-monitor">
    <div class="device-prop-time-selector-container">
      <!-- <TreeSelect :options="options" v-on:list-update="updateDeviceList"/> -->
      <el-select v-model="selectDevices" @change="getDeviceProps" >
        <el-option v-for="(item, index) of options" :key="index" :label="item.name" :value="item.id.id" ></el-option>
      </el-select>
      <!-- <TreeSelect :options="propOptions" v-on:list-update="updateDeviceList"/> -->
      <el-select v-if="deviceProps.length > 0" v-model="selectProps" >
        <el-option v-for="(item, index) of deviceProps" :key="index" :label="item.name" :value="item.propertyCategory" ></el-option>
      </el-select>

      <div class="blank-place-holder"></div>
      <timeRangeSelect v-model="timeRange"></timeRangeSelect>
      <TimeReolutionSelect v-model="timeResolution"/>
      <el-button @click="getTSDBData">查询</el-button>
      <el-button type="warning" plain @click="exportData">导出</el-button>
    </div>
    <div class="spliter"></div>
      <el-card v-for="(chartOption, index) in chartOptions" :key="index">
        <chart :options="chartOption" :ref="index"></chart>
      </el-card>
      <el-card class="table-container">
        <QueryTable :queryData="queryData" :deviceList="deviceList" ref="elTable"/>
      </el-card>
  </div>
</template>

<script>
// import { getDeviceList } from '@/api/getDeviceList.js'
import TreeSelect from '@/components/TreeSelect/index'
import TimeRangeSelect from '@/components/TimeRangeSelect'
import TimeReolutionSelect from '@/components/TimeResolutionSelect/'
import QueryTable from '@/components/QueryTable/'
import ECharts from 'vue-echarts'
import { TrueExcel } from '@/utils/exportExcel' // , Download

import { getAttributes } from '@/api/telemetry-controller'

import { getTenantDevices } from '@/api/device-controller'
import { queryDeviceData } from '@/api/tsdb-controller'

import _ from 'lodash'

// var Excel = require('exceljs/dist/es5/exceljs.browser')

function removeIdDash (str) {
  return str.substring(15, 18) + str.substring(9, 13) + str.substring(0, 8) + str.substring(19, 23) + str.substring(24)
}

export default {
  name: 'realTimeMonitor',
  components: {
    TreeSelect,
    TimeRangeSelect,
    TimeReolutionSelect,
    QueryTable,
    chart: ECharts
  },
  data () {
    return {
      // 设备列表
      deviceList: [],
      selectDevices: '',
      selectProps: [],
      timeRange: '',
      timeResolution: '',
      img64Img: '',
      // define default value
      value: null,
      // define options
      options: [],
      deviceProps: [],
      queryData: [],
      propOptions: {
        Voltage: [
          '1',
          '2',
          '3'
        ]
      },
      selectedDevice: [],
      chartOptions: [{
        title: {
          // text: 'ECharts 入门示例'
        },
        grid: {
          left: '30px',
          right: '30px',
          top: '30px',
          bottom: '30px'
        },
        tooltip: {},
        legend: {
          data: ['']
        },
        xAxis: {
          data: [],
          boundaryGap: false,
          type: 'category'
        },
        yAxis: {
          // min: function(value) {
          //   return Math.round(value.min - 30)
          // }
        },
        series: [{
          name: '',
          type: 'line',
          areaStyle: {},
          data: []
        }]
      }]
    }
  },
  created () {
    // getDeviceList().then(response => {
    //   this.options = response.data
    // })
    getTenantDevices().then(res => {
      // console.log(res.data.data)
      this.options = res.data.data
    })
  },
  methods: {
    getDeviceProps () {
      // console.log(this.selectDevices)
      getAttributes('DEVICE', this.selectDevices).then(res => {
        // console.log(JSON.parse(res.data[1].value))
        this.deviceProps = JSON.parse(res.data[1].value)
        console.log(this.deviceProps.length)
      })
    },
    updateDeviceList: function (event) {
      this.selectedDevice = event
    },
    exportData: function () {
      // let chartInstance = this.$refs.chartInstance
      // base64Img = chartInstance.getDataURL({
      //   pixelRatio: 2,
      //   backgroundColor: '#fff'
      // })
      // const excel = new trueExcel()
      const excel = new TrueExcel()
      // excel.addData(tableData)
      excel.addElTable(this.$refs.elTable.$refs.tableBody)
      excel.export()
      // console.log(this.$refs.elTable.$refs.tableBody)

      // const excels = new Download()
      // excel.tabelExportToExcel(tableData)
    },
    getTSDBData: function (params) {
      console.log(this.timeRange, this.timeResolution, this.selectDevices, this.selectProps)
      const queryData = {
        start: this.timeRange[0],
        end: this.timeRange[1],
        type: this.timeResolution,
        attributes: []
      }
      queryData.attributes[0] = removeIdDash(this.selectDevices) + '.' + this.selectProps

      queryDeviceData(queryData).then(res => {
        for (const item in res.data) {
          const dataItem = {
            date: item
          }
          for (const key in res.data[item]) {
            dataItem[key] = res.data[item][key]
            this.deviceList.push(key)
          }
          this.queryData.push(dataItem)
        }
        this.deviceList = _.uniq(this.deviceList)
        console.log(this.queryData, 'queryData', Array.isArray(this.queryData))
        const TS = Object.keys(res.data)
        let TSData = Object.values(res.data)
        TSData = TSData.map(item => {
          return Object.values(item)[0 ]
        })
        console.log(TSData)
        this.chartOptions[0].xAxis.data = TS
        this.chartOptions[0].series[0].data = TSData
      })
      // getTSDB({}).then(response => {
      //   // console.log(response.data[0].dps)
      //   const TS = Object.keys(response.data[1].dps)
      //   const PrettyTS = TS.map(TimeSeries => {
      //     // const date = new Date(TimeSeries * 1000)
      //     return new Date(TimeSeries * 1000).getMonth() + 1
      //   })
      //   const TSData = Object.values(response.data[1].dps)
      //   this.chartOptions[0].xAxis.data = PrettyTS
      //   this.chartOptions[0].series[0].data = TSData
      // })
    }
  }
}
</script>

<style lang="scss" scoped>
.real-time-monitor{
  padding: 10px;
  width: 100%;
  overflow-y: auto;
  height: 100%;
  // background-color: #66ccff;
  .device-prop-time-selector-container{
    .el-select {
      margin-right: 10px;
    }
    width: 100%;
    display: flex;
    .blank-place-holder{
      flex: auto;
    }
  }

  .spliter{
    margin: 10px 0;
    width: 100%;
    height: 1px;
    background-color: #c0c4ccda;
  }

  .el-card ::v-deep {
    margin-top: 20px;
    height: 400px;
    width: 100%;
    .el-card__body{
      height: 400px;
    }
  }
  .echarts {
    height: 100%;
    width: 100%;
  }

  .query-table-container {
    margin-top: 20px;
  }
}
.table-container {
  overflow: scroll;
}
</style>
